import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class ToolTip extends PureComponent {
  render () {
    const className = classNames(
      'ToolTip',
      this.props.className,
      {
        'ToolTip-Bottom': this.props.position === 'bottom',
        'ToolTip-Right': this.props.position === 'right',
        'ToolTip-No-Pointer': this.props.showPointer === false,
      },
    )
    let styles = {}
    if (this.props.hoverDelay) {
      styles['--tooltip-hover-delay'] = this.props.hoverDelay + 'ms'
    }
    if (this.props.minWidth) {
      styles['--tooltip-min-width'] = this.props.minWidth + 'px'
    }
    return (
      <div className={className} style={styles}>
        {this.props.children}
      </div>
    )
  }
}

ToolTip.defaultProps = {
  showPointer: true
}

ToolTip.propTypes = {
  className: PropTypes.string,
  position: PropTypes.oneOf(['bottom', 'right']),
  showPointer: PropTypes.bool,
  hoverDelay: PropTypes.number,
  minWidth: PropTypes.number,
}

export default ToolTip
